export const DATE_RANGE_OPTIONS = [
  { label: 'Last 7 days', value: '7d' },
  { label: 'Last 30 days', value: '30d' },
  { label: 'Last 3 months', value: '3m' },
  { label: 'Last 6 months', value: '6m' },
  { label: 'Last 12 months', value: '12m' }
]

export const ALL_TIME_OPTION = { label: 'All time', value: 'all' }

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric'
})

const toDate = value => (value instanceof Date ? value : new Date(value))

const toYMD = d => d.toISOString().slice(0, 10)

export function dateRangeForApi(preset, customRange, now = new Date()) {
  if (
    customRange &&
    customRange.start !== null &&
    customRange.start !== undefined &&
    customRange.end !== null &&
    customRange.end !== undefined
  ) {
    return { beginning_date: toYMD(toDate(customRange.start)), ending_date: toYMD(toDate(customRange.end)) }
  }
  const end = new Date(now)
  const start = new Date(end)
  if (preset === '7d') start.setDate(end.getDate() - 7)
  else if (preset === '30d') start.setDate(end.getDate() - 30)
  else if (preset === '3m') start.setMonth(end.getMonth() - 3)
  else if (preset === '6m') start.setMonth(end.getMonth() - 6)
  else if (preset === '12m') start.setFullYear(end.getFullYear() - 1)
  else start.setDate(end.getDate() - 30)
  return { beginning_date: toYMD(start), ending_date: toYMD(end) }
}

export function formatDateRangeLabel(start, end) {
  if (!start || !end) return ''
  const s = toDate(start)
  const e = toDate(end)
  if (isNaN(s.getTime()) || isNaN(e.getTime())) return ''
  return `${dateFormatter.format(s)} – ${dateFormatter.format(e)}`
}
